module.exports = __webpack_public_path__ + "b2f39c82b862b13de4e80ecdfc4dac85.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/water-hair-s.png
// module id = 2342
// module chunks = 0